import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=7178f7b1"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7178f7b1')) {
      api.createRecord('7178f7b1', component.options)
    } else {
      api.reload('7178f7b1', component.options)
    }
    module.hot.accept("./CompanyList.vue?vue&type=template&id=7178f7b1", function () {
      api.rerender('7178f7b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/CompanyList.vue"
export default component.exports